import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgArrowLineRight = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M16 6v12h2V6h-2ZM5.66 6l5 6-5 6h2.61l5-6-5-6H5.66Z"
    />
  </svg>
);
export default SvgArrowLineRight;
